const lookupPeriodFromInitial = {
    U: "Unknown",
    M: "Month",
    Y: "Year",
    H: "Hour",
    D: "Day",
    W: "Week",
}

export function convertPeriodLabelToFrequency(periodLabel) {
    const period = lookupPeriodFromInitial[periodLabel.at(-1)] ?? "Unknown"
    const interval = +(periodLabel.slice(0, -1) ?? 0)
    return { period, interval, label: periodLabel }
}
